var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.question
    ? _c(
        "div",
        {
          staticClass:
            "flex flex-col w-full gap-2 px-4 py-5 transition-all duration-300 border-l-8 form-question lg:w-148 lg:px-10 bg-pure-white rounded-xl",
          class: [_vm.answerInput ? "border-lime-500" : "border-slate-300"],
          attrs: { id: "question_field_" + _vm.question.id }
        },
        [
          _c("BlTextSubtitle2", { attrs: { text: _vm.question.label } }),
          _vm._v(" "),
          _vm.question.input_type === "text"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.answerInput,
                    expression: "answerInput"
                  }
                ],
                staticClass: "text-input focus:border-light-purple",
                attrs: {
                  type: "text",
                  name: "answer_input_" + _vm.question.id,
                  id: "answer_input_" + _vm.question.id,
                  placeholder: "Type here"
                },
                domProps: { value: _vm.answerInput },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.answerInput = $event.target.value
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.question.input_type === "textarea"
            ? _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.answerInput,
                    expression: "answerInput"
                  }
                ],
                staticClass: "textarea-input focus:border-light-purple",
                attrs: {
                  type: "text",
                  name: "answer_input_" + _vm.question.id,
                  id: "answer_input_" + _vm.question.id,
                  placeholder: "Type here"
                },
                domProps: { value: _vm.answerInput },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.answerInput = $event.target.value
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.question.input_type === "date"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.answerInput,
                    expression: "answerInput"
                  }
                ],
                staticClass: "text-input focus:border-light-purple",
                attrs: {
                  type: "date",
                  name: "answer_input_" + _vm.question.id,
                  id: "answer_input_" + _vm.question.id,
                  placeholder: "Type here"
                },
                domProps: { value: _vm.answerInput },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.answerInput = $event.target.value
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.question.input_type === "radio" ||
          _vm.question.input_type === "checkbox"
            ? _c(
                "div",
                { staticClass: "flex flex-col w-full gap-2" },
                [
                  _vm._l(_vm.question.input_options, function(opt, idx) {
                    return _c(
                      "div",
                      {
                        key: idx,
                        staticClass: "flex items-center gap-2 cursor-pointer",
                        attrs: { title: opt },
                        on: {
                          click: function($event) {
                            return _vm.onSelectOption(opt)
                          }
                        }
                      },
                      [
                        _vm.question.input_type === "radio"
                          ? _c("BlInputRadio", {
                              attrs: {
                                name: "answer_input_" + _vm.question.id,
                                checked: opt === _vm.answerInput
                              },
                              on: {
                                changed: function($event) {
                                  return _vm.onSelectOption(opt)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.question.input_type === "checkbox"
                          ? _c("BlInputCheck", {
                              attrs: {
                                name: "answer_input_" + _vm.question.id,
                                checked: _vm.answerInput.includes(opt)
                              },
                              on: {
                                changed: function($event) {
                                  return _vm.onSelectOption(opt)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "truncate text-slate-800",
                          attrs: { text: opt }
                        })
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.question.is_use_other
                    ? _c("div", { staticClass: "flex items-center gap-2" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center gap-2 cursor-pointer",
                            on: {
                              click: function($event) {
                                _vm.isOther = !_vm.isOther
                              }
                            }
                          },
                          [
                            _vm.question.input_type === "radio"
                              ? _c("BlInputRadio", {
                                  attrs: {
                                    name: "answer_input_" + _vm.question.id,
                                    checked: _vm.isOther
                                  },
                                  on: {
                                    changed: function($event) {
                                      _vm.isOther = !_vm.isOther
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.question.input_type === "checkbox"
                              ? _c("BlInputCheck", {
                                  attrs: {
                                    name: "answer_input_" + _vm.question.id,
                                    checked: _vm.isOther
                                  },
                                  on: {
                                    changed: function($event) {
                                      _vm.isOther = !_vm.isOther
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-slate-800",
                              attrs: { text: "Other:" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.isOther
                          ? _c("input", {
                              staticClass:
                                "opacity-50 pointer-events-none text-input bg-slate-200",
                              attrs: {
                                type: "text",
                                name: "answer_input_" + _vm.question.id,
                                id: "answer_input_" + _vm.question.id,
                                disabled: "",
                                placeholder: "Type here"
                              }
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.answerInput,
                                  expression: "answerInput"
                                }
                              ],
                              staticClass:
                                "text-input focus:border-light-purple",
                              class: {
                                "bg-slate-400 opacity-50 pointer-events-none": !_vm.isOther
                              },
                              attrs: {
                                type: "text",
                                name: "answer_input_" + _vm.question.id,
                                id: "answer_input_" + _vm.question.id,
                                disabled: !_vm.isOther,
                                placeholder:
                                  _vm.question.input_type === "radio"
                                    ? "Type here"
                                    : _vm.question.input_options.join(", ") +
                                      ", etc."
                              },
                              domProps: { value: _vm.answerInput },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.answerInput = $event.target.value
                                }
                              }
                            })
                      ])
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3776c8ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3776c8ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/prospectForm/Question.vue
// module id = null
// module chunks = 